const testimonialSwiper = new Swiper('.testimonial-display.is-swiper', {
    // Optional parameters
    loop: false,
    slidesPerView: 1,
    centeredSlides: true,
    autoplay: false,
    allowTouchMove: true, // Enable touch/swipe gestures
    pagination: {
        el: '.testimonial-display .swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.testimonials .swiper-navigation .slide-next',
        prevEl: '.testimonials .swiper-navigation .slide-prev',
    },
});